/**
 * Серия варианта ответа: цвет и буква.
 *
 * Одна и та же серия красит кнопку на телефоне, строку на проекторе и чип
 * в пульте — поэтому участник находит свой ответ на стене по цвету, не читая
 * подписей с десяти метров. Буква дублирует цвет: примерно каждый двенадцатый
 * мужчина в зале часть этих оттенков не различает.
 *
 * Сами значения живут в CSS-токенах (см. index.css), здесь только номер серии:
 * «чернильный» оттенок зависит от темы, и компоненту знать о ней незачем.
 */

import type { CSSProperties } from 'react'

/** Сколько разных цветов в палитре; дальше они идут по кругу, буквы — нет. */
export const SERIES_COUNT = 8

const LETTERS = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'

export interface Series {
  /** Заливка: одна на обе темы, поверх неё всегда тёмный текст. */
  fill: string
  /** Цвет серии как текст на фоне темы — для слов в облаке. */
  ink: string
  /** Буква варианта: A, B, C… После Z — номер, но до такого опроса дело не доходит. */
  letter: string
}

export function seriesOf(index: number): Series {
  const n = (index % SERIES_COUNT) + 1
  return {
    fill: `var(--s${n})`,
    ink: `var(--s${n}-ink)`,
    letter: LETTERS[index] ?? String(index + 1),
  }
}

/** Инлайновый стиль, который передаёт цвет серии в CSS переменной `--opt`. */
export function seriesStyle(index: number): CSSProperties {
  return { ['--opt' as string]: seriesOf(index).fill }
}
